import { defineAttrs as t } from "../../utils/typed-attrs.js";
const o = t({
  type: { default: "html" },
  content: { default: "" }
}), e = {
  content: "",
  attrs: o,
  group: "block",
  parseDOM: [{ tag: ".embercom-prosemirror-composer-html-block .intercom-interblocks-html-block" }],
  toDOM() {
    return [
      "div",
      {
        class: "embercom-prosemirror-composer-mention"
      }
    ];
  }
};
export {
  e as htmlSpec
};
